module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-23.ced55cf4.png";